import type { BuildType } from './ApiService';
import type { EarnedBadge } from '@/apiTypes/EarnedBadgeTypes';
import { isKnownBadge } from '@/components/EarnedBadge/earnedBadgeRegistry';

const knownBadges = (badges: EarnedBadge[]) => badges.filter(isKnownBadge);

export const earnedBadgeApiEndpoints = (build: BuildType) => ({
    getEarnedBadges: build.query<EarnedBadge[], void>({
        query: () => 'badges',
        transformResponse: knownBadges,
        providesTags: ['EarnedBadges'],
    }),
    getUnseenEarnedBadges: build.query<EarnedBadge[], void>({
        query: () => 'badges/unseen',
        transformResponse: knownBadges,
        providesTags: ['EarnedBadges'],
    }),
    getEarnedBadge: build.query<EarnedBadge, string>({
        query: id => `badges/${id}`,
        providesTags: ['EarnedBadges'],
    }),
    markEarnedBadgesSeen: build.mutation<void, string[]>({
        query: ids => ({ url: 'badges/seen', method: 'POST', body: { ids } }),
        invalidatesTags: ['EarnedBadges'],
    }),
});
